import { useDispatch } from "react-redux";
import { setExcludeDemoMode, setProviders } from "../../store/gamesSlice";
import { setBanners, setCasinoField } from "../../store/commonSlice";
import { useEffect } from "react";
import { API_CASINO } from "../../api/casino";
import { checkUrlBotTg, DEBUG, ENUM_LCS_NAME, TEST_MODE } from "../../store/enums";
import { testCasinoInfo, testProviders } from "../../store/testConst";
import { useLocalStorage } from "usehooks-ts";
import { getParamFromUrl, getSecondByMinutes } from "../../utils/utils";
import { setErrorInfo, setMainLoader } from "../../store/siteSlice";
import { useAppSelector } from "../../store/index.ts";

// const MINUTES = 60;
const MINUTES = 0.1;

export default function useFillCasino() {
  const dispatch = useDispatch();
  const lang = useAppSelector((state) => state.common.lang);

  const [startR, setStartR] = useLocalStorage(ENUM_LCS_NAME.startR, "");
  const [pbParams, setPbParams] = useLocalStorage(ENUM_LCS_NAME.pbParams, "");
  const [casinoInfo, setCasinoInfo] = useLocalStorage(ENUM_LCS_NAME.casinoInfo, {});

  // fillCasinoInfo - заполнение стора инфой полученный от сервера при инициализации
  const fillCasinoInfo = (data) => {
    const banners = [...(data?.banners || [])];
    const isTgBot = checkUrlBotTg();

    dispatch(setExcludeDemoMode(data.excludeFromDemo || []));
    dispatch(setCasinoField(data));

    let newBanners = banners.sort((l, r) => l.position - r.position);
    // если мы уже в боте убираем баннеры которые ведут на бота
    if (isTgBot) {
      newBanners = newBanners.filter((el) => !el.makeBotLink);
    }
    dispatch(setBanners(newBanners));
  };

  // getStartR - получение start_r
  const getStartR = () => {
    if (startR) return startR;
    const tempStartR = getParamFromUrl("start");
    if (tempStartR) setStartR(tempStartR);

    return tempStartR;
  };

  // getPbParams - получение pb_params
  const getPbParams = () => {
    if (pbParams) return pbParams;

    const queryParams = new URLSearchParams(location.search);
    queryParams.delete("start");
    queryParams.delete("mode");
    queryParams.delete("sessionId");

    const tempBpParams = queryParams.toString();
    const base64EncodedQueryString = btoa(tempBpParams);
    if (tempBpParams) setPbParams(base64EncodedQueryString);
    return tempBpParams;
  };

  const getCasinoInfo = () => {
    const start_r = getStartR() || "";
    const pb_params = getPbParams() || "";
    const isSameLang = lang == casinoInfo?.lang;

    if (isSameLang && +casinoInfo?.time + getSecondByMinutes(MINUTES) > +new Date()) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      try {
        fillCasinoInfo(casinoInfo.info, false, favoritesId);
      } catch (e) {
        console.log("error", e);

        dispatch(setErrorInfo(true));
      }

      // что бы успел прогрузиться сайт
      dispatch(setMainLoader(false));
    } else {
      API_CASINO.info({ start_r, pb_params, lang })
        .then((e) => {
          const data = e.data;
          if (!data || data.error) {
            dispatch(setErrorInfo(true));
            return;
          }
          fillCasinoInfo(e.data, true);

          setCasinoInfo({ time: +new Date(), info: e.data, lang: lang });
          if (DEBUG && e.data.error) console.log("error casino info", e.data?.error);
        })
        .catch((e) => {
          dispatch(setErrorInfo(true));
          console.error("catch casino info ", e);
        })
        .finally(() => {
          dispatch(setMainLoader(false));
        });
    }
  };

  useEffect(() => {
    if (TEST_MODE) {
      const favoritesId = JSON.parse(localStorage.getItem(ENUM_LCS_NAME.favoritesId)) || [];
      fillCasinoInfo(testCasinoInfo, false, favoritesId);
      dispatch(setMainLoader(false));
      dispatch(setProviders(testProviders));
      return;
    }

    getCasinoInfo();
  }, [lang]);
}
